<template>
  <div>
    <div class="card card-custom gutter-b" v-if="!esVersionApp">
      <div class="card-body">
        <div class="d-flex flex-column flex-lg-row align-items-stretch align-items-lg-start justify-content-between">
          <div class="flex-grow-1 min-w-0 mb-3 mb-lg-0 mr-lg-3">
            <div class="d-flex align-items-start flex-wrap">
              <span class="text-dark text-hover-primary font-size-h5 font-size-h6-sm font-weight-bold text-break pr-2">{{ fichaLocalVotacion.nombre }} <i class="flaticon2-correct text-success icon-md ml-1 ml-sm-2"></i></span>
            </div>
            <div class="font-weight-bold text-dark-50 py-3 py-lg-2 text-break">
              {{ fichaLocalVotacion.direccion }}
            </div>
            <div class="d-flex flex-wrap my-2">
              <span class="text-muted text-hover-primary font-weight-bold text-break">{{ fichaLocalVotacion.regionNombre }} / {{ fichaLocalVotacion.subRegionNombre }}</span>
            </div>
          </div>
          <div class="d-flex flex-column flex-sm-row align-items-stretch align-items-sm-center flex-shrink-0">
            <a href="#" class="btn btn-sm btn-light-primary font-weight-bolder mb-2 mb-sm-0 mr-sm-3 text-center text-sm-left" @click.prevent="imagenes.mostrarModal = true"><i class="fa fa-image"></i> Cargar imágenes</a>
            <a href="#" class="btn btn-sm btn-light-warning font-weight-bold text-center" @click.prevent="toggleExpandirTurnos()" v-b-tooltip.hover :title="todosTurnosExpandidos ? 'Contraer todos los turnos' : 'Expandir todos los turnos'"><i class="fa p-0" :class="[todosTurnosExpandidos ? 'fa-compress' : 'fa-expand']"></i></a>
          </div>
        </div>
        <div class="separator separator-solid my-5 my-lg-7"></div>
        <div class="row">
          <div class="col-12 col-md-4">
            <div class="d-flex align-items-center flex-lg-fill my-2 my-md-1 pr-md-3">
              <span class="mr-4"><i class="fa-2x fa fa-hand-paper"></i></span>
              <div class="d-flex flex-column">
                <a href="#" class=" font-weight-bold" :class="[fichaLocalVotacion.nroActosDeViolencia > 0 ? 'text-danger' : 'text-secondary']" @click.prevent="doMdlActoViolencia()">{{ fichaLocalVotacion.nroActosDeViolencia }} Actos de violencia</a>
                <a href="#" class="text-primary font-weight-bold" @click.prevent="$refs.fabRegistroIncidenteRef.reporteActoViolencia()">Registrar</a>
              </div>
            </div>
          </div>
          <div class="col-12 col-md-4">
            <div class="d-flex align-items-center flex-lg-fill my-2 my-md-1 pr-md-3">
              <span class="mr-4"><i class="fa-2x fa fa-bell"></i></span>
              <div class="d-flex flex-column">
                <a href="#" class=" font-weight-bold" :class="[fichaLocalVotacion.nroIncidentes > 0 ? 'text-danger' : 'text-secondary']" @click.prevent="doMdlIncidenteOtro()">{{ fichaLocalVotacion.nroIncidentes }} Otros incidentes</a>
                <a href="#" class="text-primary font-weight-bold" @click.prevent="$refs.fabRegistroIncidenteRef.reporteOtros()">Registrar</a>
              </div>
            </div>
          </div>
          <div class="col-12 col-md-4">
            <div class="d-flex align-items-center flex-lg-fill my-2 my-md-1">
              <span class="mr-4"><i class="fa-2x fa fa-image"></i></span>
              <div class="d-flex flex-column">
                <span class="font-weight-bold text-secondary">Imágenes</span>
                <a href="#" class="text-primary font-weight-bold" @click.prevent="imagenes.mostrarModal = true">Registrar</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <ficha-turno-1 v-if="fichaLocalVotacion.puedeVisualizarTurno1 || fichaLocalVotacion.puedeEditarTurno1" :local-votacion-id="localVotacionId" :proceso-electoral-id="procesoElectoralId" ref="fichaTurno1Ref" :expandirContenido.sync="expandirContenidoTurno1" :intervalo-auto-guardado="5000"></ficha-turno-1>
    <div class="separator mt-5" v-if="fichaLocalVotacion.puedeVisualizarTurno1 || fichaLocalVotacion.puedeEditarTurno1"></div>
    <ficha-turno-2 v-if="fichaLocalVotacion.puedeVisualizarTurno2 || fichaLocalVotacion.puedeEditarTurno2" :local-votacion-id="localVotacionId" :proceso-electoral-id="procesoElectoralId" ref="fichaTurno2Ref" :expandirContenido.sync="expandirContenidoTurno2" :intervalo-auto-guardado="5000"></ficha-turno-2>
    <div class="separator mt-5" v-if="fichaLocalVotacion.puedeVisualizarTurno2 || fichaLocalVotacion.puedeEditarTurno2"></div>
    <ficha-turno-3 v-if="fichaLocalVotacion.puedeVisualizarTurno3 || fichaLocalVotacion.puedeEditarTurno3" :local-votacion-id="localVotacionId" :proceso-electoral-id="procesoElectoralId" ref="fichaTurno3Ref" :expandirContenido.sync="expandirContenidoTurno3" :intervalo-auto-guardado="5000"></ficha-turno-3>

    <div v-if="imagenes.mostrarModal">
      <add-edit-proceso-electoral-multimedia-album v-model="imagenes.mostrarModal" :local-votacion-id="localVotacionId"></add-edit-proceso-electoral-multimedia-album>
    </div>

    <fab-registro-incidente v-if="!esVersionApp" :local-votacion-id="localVotacionId" :proceso-electoral-id="procesoElectoralId" ref="fabRegistroIncidenteRef" @incidente-registrado="handleIncidenteSaved" @acto-violencia-registrado="handleActosViolenciaSaved"></fab-registro-incidente>

    <div>
      <b-modal id="mdl-Acto-Violencia" size="lg" hide-footer content-class="ficha-sheet-modal-content">
        <template #modal-title><i class="fa fa-hand-paper"></i> Actos de Violencia</template>
        <div class="row">
          <div class="col-md-12" v-if="actosViolencia.length > 0">
            <div v-for="acto in actosViolencia" :key="acto.localVotacionFichaActosViolenciaId" class="mt-2">
              <div class="row">
                <div class="col-12 col-lg-8">
                  <h3 class="mt-0 mb-1 bg-light p-1"><strong class="font-weight-bold"><i class="fa fa-clock fa-1x"></i> {{ acto.horaEventoActo | time }}</strong></h3>
                  <div class="ml-0 ml-sm-2">
                    <h6><i class="fas fa-th-list" style="font-size:88%;"></i> Descripción de lo ocurrido</h6>
                    <p class="pl-0 pl-sm-3 pl-md-5 text-break">{{ acto.descripcionActo }}</p>
                    <h6 class="mt-1"><i class="fa fa-check" style="font-size:88%;"></i> Medidas tomadas</h6>
                    <p class="pl-0 pl-sm-3 pl-md-5 text-break">{{ acto.medidasTomadasActo }}</p>
                  </div>
                </div>
                <div class="col-12 col-lg-4 mt-3 mt-lg-0">
                  <CoolLightBox :items="acto.coolboxImages" :index="acto.coolboxIndex" :useZoomBar="true" :slideshow="true" @close="acto.coolboxIndex = null"></CoolLightBox>
                  <div class="symbol-group symbol-hover" v-if="acto.symbolImages.length > 0">
                    <div v-for="(imagen, imageIndex) in acto.symbolImages" :key="imagen.procesoElectoralMultimediaImagenId" @click="acto.coolboxIndex = imageIndex">
                      <div class="symbol symbol-50"><img alt="" :src="apiResource(imagen.rutaArchivo)" /></div>
                    </div>
                    <div class="symbol symbol-50 symbol-circle symbol-light" v-if="acto.masImagenes">
                      <span class="symbol-label font-weight-bold" @click="acto.coolboxIndex = 0">{{ acto.masImagenes }}+</span>
                    </div>
                  </div>
                </div>
              </div>
              <hr />
            </div>
          </div>
          <div v-else class="col-md-12">
            <div class="bg-light-primary p-3"><i class="fa fa-info-circle text-primary"></i> Sin registros</div>
          </div>
        </div>
      </b-modal>
    </div>

    <div>
      <b-modal id="mdl-Incidente-Otro" size="lg" hide-footer content-class="ficha-sheet-modal-content">
        <template #modal-title><i class="fa fa-bell"></i> Incidentes (otros)</template>
        <div class="row">
          <div class="col-md-12" v-if="incidentes.length > 0">
            <div v-for="incidente in incidentes" :key="incidente.localVotacionFichaIncidenteId" class="mt-2">
              <div class="row">
                <div class="col-12 col-lg-8">
                  <h3 class="mt-0 mb-1 bg-light p-1"><strong class="font-weight-bold"><i class="fa fa-clock fa-1x"></i> {{ incidente.horaEventoActo | time }}</strong></h3>
                  <div class="ml-0 ml-sm-2">
                    <h6><i class="fas fa-th-list" style="font-size:88%;"></i> Descripción de lo ocurrido</h6>
                    <p class="pl-0 pl-sm-3 pl-md-5 text-break">{{ incidente.descripcionActo }}</p>
                    <h6 class="mt-1"><i class="fa fa-check" style="font-size:88%;"></i> Autoridades que intervinieron</h6>
                    <p class="pl-0 pl-sm-3 pl-md-5 text-break">{{ incidente.autoridadIntervencion }}</p>
                    <h6 class="mt-1"><i class="fa fa-eyedropper" style="font-size:88%;"></i> Tipo de incidente</h6>
                    <p class="pl-0 pl-sm-3 pl-md-5 text-break">{{ incidente.tipoIncidenteParamDescripcion }}</p>
                    <h6 class="mt-1"><i class="fa fa-table" style="font-size:88%;"></i> Nro. de mesa</h6>
                    <p class="pl-0 pl-sm-3 pl-md-5">{{ incidente.numeroMesa ? incidente.numeroMesa : "- no especificado -" }}</p>
                  </div>
                </div>
                <div class="col-12 col-lg-4 mt-3 mt-lg-0">
                  <CoolLightBox :items="incidente.coolboxImages" :index="incidente.coolboxIndex" :useZoomBar="true" :slideshow="true" @close="incidente.coolboxIndex = null"></CoolLightBox>
                  <div class="symbol-group symbol-hover" v-if="incidente.symbolImages.length > 0">
                    <div v-for="(imagen, imageIndex) in incidente.symbolImages" :key="imagen.procesoElectoralMultimediaImagenId" @click="incidente.coolboxIndex = imageIndex">
                      <div class="symbol symbol-60"><img alt="" :src="apiResource(imagen.rutaArchivo)" /></div>
                    </div>
                    <div class="symbol symbol-60 symbol-circle symbol-light" v-if="incidente.masImagenes">
                      <span class="symbol-label font-weight-bold" @click="incidente.coolboxIndex = 0">{{ incidente.masImagenes }}+</span>
                    </div>
                  </div>
                </div>
              </div>
              <hr />
            </div>
          </div>
          <div v-else class="col-md-12">
            <div class="p-3 bg-light-primary"><i class="fa fa-info-circle text-primary"></i> Sin registros</div>
          </div>
        </div>
      </b-modal>
    </div>
  </div>
</template>

<style scoped>
.table-hover tbody tr:hover { background-color: #f9f9f9; }
@media (max-width: 575.98px) {
  .font-size-h6-sm { font-size: 1.05rem !important; line-height: 1.35; }
}
</style>
<style>
.with-status-indicator { position: relative; }
.status-indicator { position: absolute; right: -10px; top: 10px; }
@media (max-width: 575.98px) {
  .ficha-sheet-modal-content { margin: 0.25rem; max-height: calc(100vh - 0.5rem); }
}
</style>

<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import fichaTurno1 from "@/components/sheet/2026/local/ficha-turno-1";
import fichaTurno2 from "@/components/sheet/2026/local/ficha-turno-2";
import fichaTurno3 from "@/components/sheet/2026/local/ficha-turno-3";
import fabRegistroIncidente from "@/components/incident/fab-registro-incidente";
import addEditProcesoElectoralMultimediaAlbum from "@/components/multimedia/add-edit-proceso-electoral-multimedia-album";
import Swal from "sweetalert2";
import CoolLightBox from "vue-cool-lightbox";
import "vue-cool-lightbox/dist/vue-cool-lightbox.min.css";
import { INACTIVE_USER_TIME_THRESHOLD, USER_ACTIVITY_THROTTLER_TIME } from "@/helpers/constants.js";

export default {
  name: "edit-ficha-local-2026",
  components: { fichaTurno1, fichaTurno2, fichaTurno3, fabRegistroIncidente, addEditProcesoElectoralMultimediaAlbum, CoolLightBox },
  props: {
    localVotacionId: { type: Number },
    procesoElectoralId: { type: Number },
    turno: { type: Number },
    esVersionApp: { type: Boolean, default: false },
  },
  data: () => ({
    imagenes: { mostrarModal: false },
    expandirContenidoTurno1: false,
    expandirContenidoTurno2: false,
    expandirContenidoTurno3: false,
    fichaGroupKey: "",
    fichaLocalVotacion: {},
    filterFicha: { localVotacionId: null, procesoElectoralId: null },
    actosViolencia: [],
    incidentes: [],
    isInactive: false,
    userActivityThrottlerTimeout: null,
    userActivityTimeout: null,
  }),
  computed: {
    todosTurnosExpandidos() {
      return this.expandirContenidoTurno1 && this.expandirContenidoTurno2 && this.expandirContenidoTurno3;
    },
  },
  methods: {
    onFichaUpdated(params) {
      switch (params.turno) {
        case 1: this.$refs.fichaTurno1Ref.doCargarFicha(); break;
        case 2: this.$refs.fichaTurno2Ref.doCargarFicha(); break;
        case 3: this.$refs.fichaTurno3Ref.doCargarFicha(); break;
      }
      this.$bvToast.toast("Se están actualizando los datos.", { title: "Turno " + params.turno, autoHideDelay: 5000, variant: "info", appendToast: false, solid: true });
    },
    toggleExpandirTurnos() {
      if (this.todosTurnosExpandidos) {
        this.expandirContenidoTurno1 = false;
        this.expandirContenidoTurno2 = false;
        this.expandirContenidoTurno3 = false;
      } else {
        this.expandirContenidoTurno1 = true;
        this.expandirContenidoTurno2 = true;
        this.expandirContenidoTurno3 = true;
      }
    },
    handleIncidenteSaved(data) { this.fichaLocalVotacion.nroIncidentes = data.nroIncidentes; this.fetchIncidenteFicha(); },
    handleActosViolenciaSaved(data) { this.fichaLocalVotacion.nroActosDeViolencia = data.nroActosDeViolencia; this.fetchActoViolenciaFicha(); },
    fetchLocalVotacon() {
      this.showLoading();
      var model = { localVotacionId: this.localVotacionId, procesoElectoralId: this.procesoElectoralId, turno: this.turno };
      this.$http.post(this.apiRoute("Sheet", "GetFichaLocalVotacion"), model).then(function(response) {
        if (!this.procesarRespuestaErrorDefecto(response)) { this.fichaLocalVotacion = response.body.data; this.showLoading(false); }
      }, this.mostrarMensajeExcepcionVueResource);
    },
    fetchActoViolenciaFicha() {
      this.$http.post(this.apiRoute("Incident", "ListActoViolenciaFichaSeguimiento"), { ...this.filterFicha }).then(function(response) {
        if (!this.procesarRespuestaErrorDefecto(response)) {
          var items = response.body.data.items;
          var vm = this;
          if (items != null && items.length > 0) {
            for (var a = 0; a < items.length; a++) {
              items[a].coolboxIndex = null;
              if (items[a].imagenes != null && items[a].imagenes.length > 0) {
                items[a].coolboxImages = items[a].imagenes.map(function(x) { return { description: items[a].descripcionActo, thumb: vm.apiResource(x.rutaArchivoThumb), src: vm.apiResource(x.rutaArchivo) }; });
                items[a].symbolImages = items[a].imagenes.slice(0, 3);
                items[a].masImagenes = items[a].imagenes.length - items[a].symbolImages.length;
              } else { items[a].coolboxImages = []; items[a].symbolImages = 0; items[a].masImagenes = 0; }
            }
          }
          this.actosViolencia = items;
        }
      }, this.mostrarMensajeExcepcionVueResource);
    },
    fetchIncidenteFicha() {
      this.$http.post(this.apiRoute("Incident", "ListIncidenteFichaSeguimiento"), { ...this.filterFicha }).then(function(response) {
        if (!this.procesarRespuestaErrorDefecto(response)) {
          var items = response.body.data.items;
          var vm = this;
          if (items.length > 0) {
            for (var a = 0; a < items.length; a++) {
              items[a].coolboxIndex = null;
              if (items[a].imagenes != null && items[a].imagenes.length > 0) {
                items[a].coolboxImages = items[a].imagenes.map(function(x) { return { description: items[a].descripcionActo, thumb: vm.apiResource(x.rutaArchivoThumb), src: vm.apiResource(x.rutaArchivo) }; });
                items[a].symbolImages = items[a].imagenes.slice(0, 3);
                items[a].masImagenes = items[a].imagenes.length - items[a].symbolImages.length;
              } else { items[a].coolboxImages = []; items[a].symbolImages = 0; items[a].masImagenes = 0; }
            }
          }
          this.incidentes = items;
        }
      }, this.mostrarMensajeExcepcionVueResource);
    },
    doMdlActoViolencia() { this.$bvModal.show("mdl-Acto-Violencia"); },
    doMdlIncidenteOtro() { this.$bvModal.show("mdl-Incidente-Otro"); },
    activateActivityTracker() {
      window.addEventListener("mousedown", this.userActivityThrottler);
      window.addEventListener("mousemove", this.userActivityThrottler);
      window.addEventListener("scroll", this.userActivityThrottler);
      window.addEventListener("keydown", this.userActivityThrottler);
      window.addEventListener("resize", this.userActivityThrottler);
      window.addEventListener("touchstart", this.userActivityThrottler);
    },
    deactivateActivityTracker() {
      window.removeEventListener("mousedown", this.userActivityThrottler);
      window.removeEventListener("mousemove", this.userActivityThrottler);
      window.removeEventListener("scroll", this.userActivityThrottler);
      window.removeEventListener("keydown", this.userActivityThrottler);
      window.removeEventListener("resize", this.userActivityThrottler);
      window.removeEventListener("touchstart", this.userActivityThrottler);
    },
    resetUserActivityTimeout() {
      clearTimeout(this.userActivityTimeout);
      this.userActivityTimeout = setTimeout(() => { this.userActivityThrottler(); this.inactiveUserAction(); }, INACTIVE_USER_TIME_THRESHOLD);
    },
    userActivityThrottler() {
      if (this.isInactive) this.isInactive = false;
      if (!this.userActivityThrottlerTimeout) {
        this.userActivityThrottlerTimeout = setTimeout(() => { this.resetUserActivityTimeout(); clearTimeout(this.userActivityThrottlerTimeout); this.userActivityThrottlerTimeout = null; }, USER_ACTIVITY_THROTTLER_TIME);
      }
    },
    inactiveUserAction() {
      this.isInactive = true;
      Swal.fire({ icon: "warning", title: "Sesión Expirada", text: "Su sesión ha expirado. Por favor vuelva a iniciar sesión.", confirmButtonText: "Iniciar Sesión" }).then((result) => {
        if (result.isConfirmed) { this.deactivateActivityTracker(); clearTimeout(this.userActivityTimeout); clearTimeout(this.userActivityThrottlerTimeout); this.$router.push({ name: "login" }); }
      });
    },
  },
  mounted() {
    this.fichaGroupKey = "FI-" + this.procesoElectoralId + "-" + this.localVotacionId;
    this.filterFicha.localVotacionId = this.localVotacionId;
    this.filterFicha.procesoElectoralId = this.procesoElectoralId;
    var vm = this;
    setTimeout(function() { vm.$notifyHub.subscribeFichaGroup(vm.fichaGroupKey); vm.$notifyHub.$on("ficha-updated", vm.onFichaUpdated); }, 1000);
    this.$store.dispatch(SET_BREADCRUMB, [{ title: "Ficha de Observación Electoral" }]);
    this.initParsley();
    this.fetchLocalVotacon();
    this.fetchActoViolenciaFicha();
    this.fetchIncidenteFicha();
    this.activateActivityTracker();
    this.expandirContenidoTurno1 = this.turno == 1;
    this.expandirContenidoTurno2 = this.turno == 2;
    this.expandirContenidoTurno3 = this.turno == 3;
  },
  beforeDestroy() {
    this.$notifyHub.unsubscribeFichaGroup(this.fichaGroupKey);
    this.$notifyHub.$off("ficha-updated", this.onFichaUpdated);
  },
};
</script>
